// Matches the list on the backend
// TODO: Have this in one place
export const CSS_VALUES_TO_COLLECT = new Set([
  "display",
  "flex-direction",
  "flex-grow",
  "flex-shrink",
  "font-family",
  "align-items",
  "justify-content",
  "column-gap",
  "row-gap",
  "flex-wrap",
  "align-content",
  "overflow",
  "text-align",
  "width",
  "max-width",
  "min-width",
  "height",
  "max-height",
  "min-height",
  "font-size",
  "line-height",
  "padding",
  "padding-left",
  "padding-right",
  "padding-top",
  "padding-bottom",
  "margin",
  "margin-left",
  "margin-right",
  "margin-top",
  "margin-bottom",
  "border-radius",
  "font-family",
  "font-weight",
  "object-fit",
  "background-clip",
  "border-left-style",
  "border-top-style",
  "border-right-style",
  "border-bottom-style",
  "border-left-width",
  "border-top-width",
  "border-right-width",
  "border-bottom-width",
  "border-left-color",
  "border-top-color",
  "border-right-color",
  "border-bottom-color",
  "background-color",
  "color",
  "transform",
  "border-top-left-radius",
  "border-top-right-radius",
  "border-bottom-right-radius",
  "border-bottom-left-radius",
  "letter-spacing",
  "opacity",
  "font-style",
  "text-decoration-line",
  "top",
  "left",
  "right",
  "bottom",
  "position",
  "background-image",
]);

export const CSS_VALUES_TO_COLLECT_FOR_PARENT = new Set([
  "display",
  "flex-direction",
]);

// These values are always broken down into components (e.g. padding-left, padding-top, padding-right, padding-bottom)
export const EXPANDABLE_CSS_VALUES = new Set(["padding", "margin"]);

// These values can only be parsed in pixels so we need to get them from the browser
// TODO: Improve this, either by supported non-pixel setting of these values, or by parsing the non-pixel ones to pixel
export const CSS_VALUES_TO_GET_FROM_BROWSER = new Set([
  "padding",
  "margin",
  "border-radius",
]);

export enum ScreenType {
  Mobile,
  Tablet,
  Laptop,
  Desktop,
}

export const SCREEN_SIZES: {
  name: string;
  width: number;
  height: number;
  type: ScreenType;
  tailwind: boolean;
}[] = [
  {
    name: "iPhone 14",
    width: 390,
    height: 844,
    type: ScreenType.Mobile,
    tailwind: false,
  },
  {
    name: "iPhone 14 Pro Max",
    width: 430,
    height: 932,
    type: ScreenType.Mobile,
    tailwind: false,
  },
  {
    name: "iPad Pro 11”",
    width: 834,
    height: 1194,
    type: ScreenType.Tablet,
    tailwind: false,
  },
  {
    name: "MacBook Air",
    width: 1280,
    height: 832,
    type: ScreenType.Laptop,
    tailwind: false,
  },
  {
    name: "MacBook Pro 14”",
    width: 1512,
    height: 982,
    type: ScreenType.Laptop,
    tailwind: false,
  },
  {
    name: "MacBook Pro 16”",
    width: 1728,
    height: 1117,
    type: ScreenType.Laptop,
    tailwind: false,
  },
  {
    name: "Desktop",
    width: 1440,
    height: 1024,
    type: ScreenType.Desktop,
    tailwind: false,
  },
  {
    name: "sm",
    width: 640,
    // @ts-expect-error TS2322
    height: null,
    type: ScreenType.Mobile,
    tailwind: true,
  },
  {
    name: "md",
    width: 768,
    // @ts-expect-error TS2322
    height: null,
    type: ScreenType.Mobile,
    tailwind: true,
  },
  {
    name: "lg",
    width: 1024,
    // @ts-expect-error TS2322
    height: null,
    type: ScreenType.Laptop,
    tailwind: true,
  },
  {
    name: "xl",
    width: 1280,
    // @ts-expect-error TS2322
    height: null,
    type: ScreenType.Laptop,
    tailwind: true,
  },
  {
    name: "2xl",
    width: 1536,
    // @ts-expect-error TS2322
    height: null,
    type: ScreenType.Desktop,
    tailwind: true,
  },
];

export const DEFAULT_SCREEN_SIZE = {
  name: "MacBook Pro 14”",
  width: 1512,
  height: 982,
  type: ScreenType.Laptop,
  tailwind: false,
};

export const DEFAULT_MOBILE_SCREEN_SIZE = {
  name: "iPhone 14 Pro Max",
  width: 430,
  height: 932,
  type: ScreenType.Mobile,
  tailwind: false,
};

const screenSizeMap = {};
SCREEN_SIZES.forEach((size) => {
  screenSizeMap[size.name] = size;
});

export const SCREEN_SIZE_NAME_TO_SIZE = screenSizeMap;

export enum STORYBOARD_TYPES {
  APPLICATION = "APPLICATION",
  COMPONENT = "COMPONENT",
  STORY = "STORY",
}

export const STORYBOARD_TYPES_WITH_MINIMAL_HEADER = new Set([
  STORYBOARD_TYPES.COMPONENT,
  STORYBOARD_TYPES.STORY,
]);

export const EMPTY_TREE_CODEBASE_ID = "EMPTY-TREE";
export const SKIP_ROOT_CODEBASE_ID = "SKIP-ROOT";

// client-side statuses
export enum STORYBOARD_STATUS {
  LOADING = "loading",
  FROZEN = "frozen",
  LIVE = "live",
}

export enum STORYBOARD_HYDRATION_STATUS {
  OTHER_ERROR = "other_error",
  ERROR = "error",
  NO_ERROR = "no_error",
}

export const COLOR_LIST = [
  {
    key: "grey",
    label: "Grey",
    value: "#BFC2C7",
  },
  {
    key: "dark-grey",
    label: "Dark Grey",
    value: "#97A2B1",
  },
  {
    key: "purple",
    label: "Purple",
    value: "#6448EF",
  },
  {
    key: "blue",
    label: "Blue",
    value: "#58B2CB",
  },
  {
    key: "green",
    label: "Green",
    value: "#6AB586",
  },
  {
    key: "yellow",
    label: "Yellow",
    value: "#EBCB62",
  },
  {
    key: "orange",
    label: "Orange",
    value: "#E59D59",
  },
  {
    key: "pink",
    label: "Pink",
    value: "#F0CAC3",
  },
  {
    key: "red",
    label: "Red",
    value: "#DA615C",
  },
];

export const CANVAS_BACKGROUND_COLOR = "#222226";
